var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-text",
        {
          staticClass: "pa-3"
        },
        [
          _c(
            "h2",
            {
              staticClass: "body-1 mt-0 mb-3"
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "pb-1",
                  attrs: {
                    size: "24",
                    color: "primary",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("mdi-application-brackets")]
              ),
              _c(
                "span",
                {
                  staticClass: "ml-2"
                },
                [_vm._v(_vm._s(_vm.title))]
              )
            ],
            1
          ),
          _vm.renderedMarkdown
            ? _c("div", {
                staticClass: "vds-app-info__md",
                domProps: {
                  innerHTML: _vm._s(_vm.renderedMarkdown)
                }
              })
            : _vm._e(),
          _vm.params.length
            ? _c("v-simple-table", {
                staticClass: "mt-3",
                attrs: {
                  dense: ""
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function fn() {
                        return [
                          _c(
                            "tbody",
                            _vm._l(_vm.params, function(p, i) {
                              return _c(
                                "tr",
                                {
                                  key: i
                                },
                                [
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "font-weight-medium vds-app-info__label"
                                    },
                                    [_vm._v(_vm._s(p.label))]
                                  ),
                                  _c(
                                    "td",
                                    [
                                      _vm.isUrl(p.value)
                                        ? _c(
                                            "a",
                                            {
                                              staticClass: "vds-app-info__link",
                                              attrs: {
                                                href: p.value,
                                                target: "_blank",
                                                rel: "noopener noreferrer"
                                              }
                                            },
                                            [_vm._v(_vm._s(p.value))]
                                          )
                                        : _c("kvm-copyable", {
                                            attrs: {
                                              value: p.value
                                            }
                                          })
                                    ],
                                    1
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  3817645910
                )
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }